module.exports = __webpack_public_path__ + "static/media/testt.5c7bb058.jpg";